// Features that have been retired from the product but whose code is still in
// the tree.
//
// A NAMED CONSTANT RATHER THAN DELETED CODE, because retiring a feature and
// removing it are different jobs on different timescales. Hiding it is urgent;
// unpicking the reducers, the actions, the admin screens and the stored answers
// is not, and doing both at once is how a quick fix turns into a risky one.
//
// Flipping one of these back to true restores the feature exactly as it was.

// THE AVERPOINT QUIZ, retired. Students were still finding it on the News and
// Channel pages, taking it, and then disputing the answers - which is support
// load for something nobody intends to maintain.
//
// This hides the ways IN (the per-article Quiz link, the sidebar's Weekly Quiz
// card) and the quiz view itself, so a stale showChannelPageQuiz in an open tab
// cannot put a student back into it.
//
// Deliberately NOT hidden:
//   - the admin quiz screens, including Quiz question disputes. Disputes
//     already filed still have to be read and answered.
//   - the extension's ArticleQuiz route, which is a separate surface.
//   - the "Questions" count on an article, which is questions-to-point and a
//     different feature that happens to share the word.
export const QUIZ_RETIRED = true;
